import { logMessage } from './sentry';

export function createUnmountOnCall(containerHtmlElement: HTMLElement) {
  return function unmountOnCall(fn: (...args: any) => void, ...args: any) {
    fn(...args);
    try {
      const node = containerHtmlElement;
      while (node.firstChild) {
        node.removeChild(node.firstChild);
      }
    } catch (error) {
      logMessage('unmountOnCall error', {
        error: (error as any).message
      });
    }
  };
}
